<div class="ticket-form">
    <div *ngIf="error" class="sw-alert sw-alert-error">{{ error }}</div>

    <div class="sw-field">
        <label class="sw-label" for="sw-summary">Subject</label>
        <input id="sw-summary" class="sw-input" type="text" placeholder="Brief summary of your issue"
            [(ngModel)]="summary" [disabled]="submitting" maxlength="200" />
    </div>

    <div class="sw-field">
        <label class="sw-label" for="sw-description">Description</label>
        <textarea id="sw-description" class="sw-textarea" placeholder="Please describe the issue in detail..."
            [(ngModel)]="description" [disabled]="submitting" rows="5"></textarea>
    </div>

    <!-- Attachments -->
    <div class="sw-field">
        <label class="sw-label">Attachments</label>
        <div class="sw-attachments">
            <div *ngFor="let file of attachments; let i = index" class="sw-attachment-item">
                <span class="sw-attachment-name">{{ file.name }}</span>
                <span class="sw-attachment-size">{{ formatFileSize(file.size) }}</span>
                <button class="sw-attachment-remove" (click)="removeAttachment(i)" [disabled]="submitting">&times;</button>
            </div>
            <div class="sw-attach-actions">
                <button class="sw-attach-btn" (click)="captureScreenshot()" [disabled]="submitting || capturing" type="button">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
                        <circle cx="8.5" cy="8.5" r="1.5" />
                        <polyline points="21 15 16 10 5 21" />
                    </svg>
                    {{ capturing ? 'Capturing...' : 'Screenshot page' }}
                </button>
                <label class="sw-attach-btn" [class.disabled]="submitting">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48" />
                    </svg>
                    Add file
                    <input type="file" multiple [accept]="uploadAccept" (change)="onFileSelected($event)" [disabled]="submitting" hidden />
                </label>
            </div>
            <span class="sw-attach-hint">or paste a screenshot (Ctrl+V)</span>
        </div>
    </div>

    <div class="ticket-form-actions">
        <button class="sw-btn sw-btn-outline" (click)="cancel.emit()" [disabled]="submitting">Cancel</button>
        <button class="sw-btn sw-btn-primary" (click)="submit()" [disabled]="!isValid || submitting">
            <span *ngIf="!submitting">Submit Request</span>
            <span *ngIf="submitting" class="sw-btn-loading">
                <span class="sw-spinner-sm"></span> Submitting...
            </span>
        </button>
    </div>
</div>
